// Copyright (C) 2017-2023 Smart code 203358507

const React = require('react');
const { useCore } = require('stremio/core');
const { useModelState } = require('stremio/common');
const { useRouteActive } = require('stremio/common/useRouteFocused');
const { foregroundRefresh } = require('../../caroline/catalogs/foregroundRefresh');
const reloadBoard = require('../../caroline/catalogs/reloadBoard');

const useBoard = () => {
    const core = useCore();
    const routeActive = useRouteActive();
    const rangeRef = React.useRef(null);
    const refreshClock = React.useRef({ lastAttempt: Date.now() });
    const action = React.useMemo(() => ({
        action: 'Load',
        args: {
            model: 'CatalogsWithExtra',
            args: { extra: [] }
        }
    }), []);
    const loadRange = React.useCallback((range) => {
        rangeRef.current = range;
        core.transport.dispatch({
            action: 'CatalogsWithExtra',
            args: {
                action: 'LoadRange',
                args: range
            }
        }, 'board');
    }, [core.transport]);
    const board = useModelState({ model: 'board', action });
    React.useEffect(() => {
        if (!routeActive) return;
        return foregroundRefresh({
            clock: refreshClock.current,
            isActive: () => routeActive,
            refresh: (active) => reloadBoard({ transport: core.transport, action, active, range: rangeRef.current }),
        });
    }, [routeActive, core.transport, action]);
    return [board, loadRange];
};

module.exports = useBoard;
